const FILE_ONLY = 'file_only';
const DESCRIPTION_ONLY = 'description_only';

export { DESCRIPTION_ONLY, FILE_ONLY };
